import { Discount } from '../models/serializable/discounts/discount.js';
import { Price } from '../models/serializable/price.js';
import { OpenTicketPass } from '../models/serializable/discounts/open-ticket-pass.js';
import { isNotNullOrUndefined, isNullOrUndefined } from '../utility/null-safety.js';
import { DiscountModifier, DiscountProvider } from './discount-provider.js';
import { DiscountFactory } from '../factories/discount-factory.js';

export class OpenTicketPassDiscountProvider extends DiscountProvider {
  private uses: number;

  constructor(private readonly openPass: OpenTicketPass) {
    super();
    this.uses = this.openPass.uses ?? 0;
  }

  findDiscountForSingleTicket(ticketId: string): Discount | null {
    if(!this.doesSeasonPassApplyToTicket(ticketId)) {
      return null;
    }
    if(this.uses >= this.openPass.maxUses) {
      return null;
    }

    return this._findDiscountForSingleTicket();
  }

  findDiscountForMultipleTickets(ticketId: string, quantity: number): DiscountModifier | null {
    if(!this.doesSeasonPassApplyToTicket(ticketId)) {
      return null;
    }
    if(this.uses >= this.openPass.maxUses) {
      return null;
    }

    if(isNotNullOrUndefined(quantity) && quantity > 1) {
      return this._findDiscountForMultipleTickets(quantity);
    }
    else {
      const discount = this._findDiscountForSingleTicket();
      return { discount, availableUses: 1 };
    }
  }

  findDiscountForOrder(orderPrice: Price): Discount | null {
    return null;
  }

  reset(): void {
    this.uses = this.openPass.uses ?? 0;
  }

  private doesSeasonPassApplyToTicket(ticketId: string): boolean {
    const validTicketIds = this.openPass.ticketId;
    return (isNullOrUndefined(validTicketIds) || validTicketIds.includes(ticketId));
  }

  private _findDiscountForSingleTicket(): Discount {
    this.uses++;
    return DiscountFactory.fromOpenTicketPass(this.openPass);
  }

  private _findDiscountForMultipleTickets(quantity: number): DiscountModifier {
    const discount = DiscountFactory.fromOpenTicketPass(this.openPass);
    const availableUses = (this.openPass.maxUses == null) ? quantity : Math.min(quantity, this.openPass.maxUses - this.uses);

    this.uses += availableUses;

    return { discount, availableUses };
  }
}
